import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  ListContainer: {
    backgroundColor: '#fff',
    flex: 1,
    paddingTop: 20,
  },
});
